import { apiService } from './apiService';

class NotificationService {
  async getNotifications(page = 1, perPage = 20) {
    try {
      const response = await apiService.get(
        `/api/v1/notifications?page=${page}&per_page=${perPage}`
      );
      return { success: true, data: response };
    } catch (error) {
      return { success: false, message: error.message, error };
    }
  }

  async getUnreadCount() {
    try {
      const response = await apiService.get('/api/v1/notifications/unread_count');
      return { success: true, count: response.count ?? 0 };
    } catch (error) {
      return { success: false, count: 0, error };
    }
  }

  async markAsRead(id) {
    try {
      const response = await apiService.put(`/api/v1/notifications/${id}/read`);
      return { success: true, data: response };
    } catch (error) {
      return { success: false, message: error.message, error };
    }
  }

  async markAllAsRead() {
    try {
      const response = await apiService.put('/api/v1/notifications/read_all');
      return { success: true, data: response };
    } catch (error) {
      return { success: false, message: error.message, error };
    }
  }
}

export const notificationService = new NotificationService();
